import { ButtonInterface } from "./ButtonInterface";
import { ButtonType } from "./ButtonType";

export class ButtonIcon implements ButtonInterface {
  private currentIcon;
  constructor(
    private name: string,
    private byDefault: boolean,
    private clickable: boolean,
    private icon: string,
    private clicked = false,
    protected brothersCanUnclick: boolean,
    protected unclickByItself: boolean,
    private alternativeIcon?: string
  ) {
    this.currentIcon = icon;
  }
  setClicked(clicked: boolean) {
    this.clicked = clicked;
  }
  isClicked() {
    return this.clicked;
  }
  toogle() {
    this.clicked = !this.clicked;
  }

  getImage() {
    throw new Error("Method not implemented.");
  }
  getColor() {
    throw new Error("Method not implemented.");
  }
  getFriendlyName() {
    return this.name;
  }

  getByDefault() {
    return this.byDefault;
  }

  canBeSelected() {
    return this.clickable;
  }

  //Se usa para cambiar íconos del propio botón
  toogleIcon() {
    if (this.alternativeIcon) {
      this.currentIcon =
        this.currentIcon === this.icon ? this.alternativeIcon : this.icon;
    }
  }

  getCurrentIcon() {
    return this.currentIcon;
  }

  getIcon() {
    return this.icon;
  }

  //Se usa para cambiar el ícono de padre
  setIcon(icon) {
    this.icon = icon;
    this.currentIcon = icon;
  }
  getAlternativeIcon() {
    return this.alternativeIcon;
  }

  getType() {
    return ButtonType.ICON;
  }

  canBrothersUnclick() {
    return this.brothersCanUnclick;
  }

  canUnclickByItself() {
    return this.unclickByItself;
  }
}
